module.exports = __webpack_public_path__ + "img/image_q_3.webp";